module.exports = __webpack_public_path__ + "img/importstep2.12288a38.png";